import Vue from 'vue';

Vue.directive('select-on-focus', {
  inserted($element) {
    $element.addEventListener('focus', () => {
      $element.setSelectionRange(0, $element.value.length);
    });
  },
});
